import React from 'react'
const context = React.createContext(({
    listener,
    key,
    event
})=>undefined);
export default context;